// Copyright 2026 NXGN Management, LLC. All Rights Reserved.

// These constants are injected at build time by Vite (see vite.config.ts).
declare const __BUILD_VERSION__: string
declare const __BUILD_COMMIT__: string
declare const __BUILD_DATE__: string

export const buildInfo = {
  version: __BUILD_VERSION__,
  commit: __BUILD_COMMIT__,
  date: __BUILD_DATE__,
}
